import Button from '@insided/control/uikit/Button'

import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
// eslint-disable-next-line import/no-internal-modules
} from '@insided/deprecated-preact-components/modal'

interface MarkAsSpamModalProps {
  numberOfSelectedItems: number
  isOpen: boolean
  onMarkAsSpam: () => void
  onClose: () => void
  entity: string
}

const MarkAsSpamModal = ({ numberOfSelectedItems, isOpen, onMarkAsSpam, onClose, entity }: MarkAsSpamModalProps) => {
    const topicConfirmation = numberOfSelectedItems > 1 ? `The ${numberOfSelectedItems} selected topics will not be visible in the community anymore, and the authors will be banned. Please note that any selected articles and product updates will be skipped.` : 'The selected topic will not be visible in the community anymore, and the author will be banned. Please note that any selected articles and product updates will be skipped.'
    const ideaConfirmation = numberOfSelectedItems > 1 ? `The ${numberOfSelectedItems} selected ideas will not be visible in the community anymore, and the authors will be banned.` : 'The selected idea will not be visible in the community anymore, and the author will be banned.'
    const bodyText = entity === 'topic' ? topicConfirmation : ideaConfirmation

  return (
    <Modal isOpen={isOpen} size='medium'>
      <ModalHeader title='Mark as spam?' onClose={() => onClose()} />
      <ModalBody>
        <div className='mark-as-spam-modal'>
          <p>{bodyText}</p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          title={`Mark as spam and ban the author${numberOfSelectedItems > 1 ? 's' : ''}`}
          onClick={onMarkAsSpam}
          size='medium'
          variant='warning'
          className='qa-confirm-mark-as-spam'
        />
        <Button title='Cancel' onClick={onClose} size='medium' />
      </ModalFooter>
    </Modal>
  )
}

export default MarkAsSpamModal
